import LaddaButton from 'App/components/LaddaButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const ConfirmMigrationModal = ({ onClose, migratePatientHandler }) => {
    const [showLoader, setShowLoader] = useState(false);

    const onConfirm = () => {
        setShowLoader(true);
        migratePatientHandler();
    };
    return (
        <Modal show>
            <Modal.Body>
                <h4 className="text-center">WARNING</h4>
                <div className="text-center">Are you sure you want to migrate this patient?</div>
            </Modal.Body>
            <Modal.Footer>
                <div className="form-button-group">
                    <Button variant="outline-secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <LaddaButton variant="danger" onClick={onConfirm} isLoading={showLoader}>
                        Confirm
                    </LaddaButton>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

ConfirmMigrationModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    migratePatientHandler: PropTypes.func.isRequired,
};

export default ConfirmMigrationModal;
